import { csrfToken } from "@/components/ShareButton"

const sent = new Set<string>()
// The last few pages visited (see inertia.tsx), to see how the player got to the crash.
const trail: string[] = []
export const rememberPage = (url: string) => {
  if (trail[trail.length - 1] === url) return
  trail.push(url)
  if (trail.length > 5) trail.shift()
}
// Noise, not crashes: browser extensions' scripts (no details, "Script error.") and the browser's own layout warning.
const IGNORED = [/^Script error\.?$/, /ResizeObserver loop/]

// Tells the server a page broke in the browser, for Sentry, without waiting on it. Each different message goes once per page
// load, so an error that repeats doesn't flood it.
// componentStack: the chain of screen parts a drawing crash happened in, from React.
export const reportCrash = (error: unknown, where: string, componentStack?: string) => {
  const message = error instanceof Error ? error.message : String(error)
  if (!message || sent.has(message) || IGNORED.some((pattern) => pattern.test(message))) return
  sent.add(message)
  void fetch("/client-errors", {
    method: "POST",
    keepalive: true,
    headers: { "X-CSRF-Token": csrfToken(), "Content-Type": "application/json" },
    body: JSON.stringify({
      message,
      stack: error instanceof Error ? error.stack : undefined,
      page: location.pathname + location.search,
      where,
      componentStack,
      commit: __COMMIT__,
      screen: `${innerWidth}×${innerHeight} ${innerWidth > innerHeight ? "sideways" : "upright"}`,
      trail: trail.join(" → "),
    }),
  }).catch(() => undefined)
}
